import { Skeleton } from 'antd'
import styles from '../../../../../../testrun.module.css'

export default function SkeletonCommentHistory({ count = 2 }) {
    return (
        <div className={styles.commentHistoryPanel}>
            <div className={styles.commentHistoryHeader}>
                <div>
                    <Skeleton.Input
                        active
                        size="small"
                        style={{ width: 64, minWidth: 64, height: 12 }}
                    />
                    <Skeleton.Input
                        active
                        size="small"
                        style={{
                            width: 130,
                            minWidth: 130,
                            height: 18,
                            marginTop: 6,
                        }}
                    />
                </div>
                <Skeleton.Avatar
                    active
                    size={26}
                    shape="circle"
                    style={{ flexShrink: 0 }}
                />
            </div>

            <ul className={styles.commentTimeline}>
                {Array.from({ length: count }).map((_, idx) => (
                    <li key={idx} className={styles.commentItem}>
                        <div className={styles.commentItemRail}>
                            <span className={styles.commentItemDot} />
                        </div>
                        <div className={styles.commentItemCard}>
                            <div className={styles.commentItemMeta}>
                                <Skeleton.Input
                                    active
                                    size="small"
                                    style={{
                                        width: 72,
                                        minWidth: 72,
                                        height: 12,
                                    }}
                                />
                                <Skeleton.Input
                                    active
                                    size="small"
                                    style={{
                                        width: 110,
                                        minWidth: 110,
                                        height: 12,
                                    }}
                                />
                            </div>
                            <Skeleton
                                active
                                title={false}
                                paragraph={{
                                    rows: 2,
                                    width: ['100%', '68%'],
                                }}
                            />
                            <div className={styles.resultSkeletonThumbs}>
                                <Skeleton.Image
                                    active
                                    style={{
                                        width: 72,
                                        height: 54,
                                        borderRadius: 6,
                                    }}
                                />
                            </div>
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    )
}
